export const MAX_STANDARD_INSTALLMENT_TOTAL = 600;
export const MAX_INSTALLMENT_LEDGER_CHANGES = 24;

export const INSTALLMENT_COUNT_ISSUES = Object.freeze({
  TOTAL_REQUIRED: "totalRequired",
  TOTAL_INTEGER: "totalInteger",
  TOTAL_RANGE: "totalRange",
  PAID_REQUIRED: "paidRequired",
  PAID_INTEGER: "paidInteger",
  PAID_NON_NEGATIVE: "paidNonNegative",
  PAID_EXCEEDS_TOTAL: "paidExceedsTotal",
  PAID_CHANGE_LIMIT: "paidChangeLimit",
});

function safeInteger(value) {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isSafeInteger(number) ? number : null;
}

export function validateStandardInstallmentCounts({ total, paid, previousPaid = null } = {}) {
  const normalizedTotal = safeInteger(total);
  const normalizedPaid = safeInteger(paid);
  const errors = [];
  const issues = [];

  if (total === "" || total === null || total === undefined) {
    issues.push(INSTALLMENT_COUNT_ISSUES.TOTAL_REQUIRED);
    errors.push("taksitSayisi");
  } else if (normalizedTotal === null) {
    issues.push(INSTALLMENT_COUNT_ISSUES.TOTAL_INTEGER);
    errors.push("taksitSayisi");
  } else if (normalizedTotal < 1 || normalizedTotal > MAX_STANDARD_INSTALLMENT_TOTAL) {
    issues.push(INSTALLMENT_COUNT_ISSUES.TOTAL_RANGE);
    errors.push("taksitSayisi");
  }

  if (paid === "" || paid === null || paid === undefined) {
    issues.push(INSTALLMENT_COUNT_ISSUES.PAID_REQUIRED);
    errors.push("odenenTaksit");
  } else if (normalizedPaid === null) {
    issues.push(INSTALLMENT_COUNT_ISSUES.PAID_INTEGER);
    errors.push("odenenTaksit");
  } else if (normalizedPaid < 0) {
    issues.push(INSTALLMENT_COUNT_ISSUES.PAID_NON_NEGATIVE);
    errors.push("odenenTaksit");
  } else if (normalizedTotal !== null && normalizedTotal >= 1 && normalizedPaid > normalizedTotal) {
    issues.push(INSTALLMENT_COUNT_ISSUES.PAID_EXCEEDS_TOTAL);
    errors.push("odenenTaksit");
  }

  const normalizedPreviousPaid = safeInteger(previousPaid);
  if (
    !errors.includes("odenenTaksit")
    && normalizedPreviousPaid !== null
    && normalizedPaid !== null
    && Math.abs(normalizedPaid - normalizedPreviousPaid) > MAX_INSTALLMENT_LEDGER_CHANGES
  ) {
    issues.push(INSTALLMENT_COUNT_ISSUES.PAID_CHANGE_LIMIT);
    errors.push("odenenTaksit");
  }

  return {
    valid: errors.length === 0,
    errors: Array.from(new Set(errors)),
    issues,
    total: normalizedTotal,
    paid: normalizedPaid,
  };
}
